const OffRoadSmall = ({ ...props }) => {
  return (
    <svg
      width="20"
      height="23"
      viewBox="0 0 20 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M0.3125 19.6172L3.98631 21.8215L7.66012 19.6172L11.3339 21.8215L15.0077 19.6172L18.6816 21.8215"
        stroke="#939393"
        strokeMiterlimit="10"
      />
      <path
        d="M0.3125 1.24805L3.98631 3.45233L7.66012 1.24805L11.3339 3.45233L15.0077 1.24805L18.6816 3.45233"
        stroke="#939393"
        strokeMiterlimit="10"
      />
      <path d="M0.3125 15.1348H2.3125" stroke="#939393" strokeMiterlimit="10" />
      <path
        d="M8.87256 15.1348H10.8726"
        stroke="#939393"
        strokeMiterlimit="10"
      />
      <path d="M17.353 15.1348H19.353" stroke="#939393" strokeMiterlimit="10" />
      <path d="M0.3125 7.83594H2.3125" stroke="#939393" strokeMiterlimit="10" />
      <path
        d="M8.87256 7.83594H10.8726"
        stroke="#939393"
        strokeMiterlimit="10"
      />
      <path d="M17.353 7.83594H19.353" stroke="#939393" strokeMiterlimit="10" />
      <path
        d="M4.55566 11.4551H6.55566"
        stroke="#939393"
        strokeMiterlimit="10"
      />
      <path
        d="M13.1094 11.4551H15.1094"
        stroke="#939393"
        strokeMiterlimit="10"
      />
    </svg>
  )
}

export default OffRoadSmall
